import { render, staticRenderFns } from "./Main.vue?vue&type=template&id=7b85789e&scoped=true"
import script from "./Main.vue?vue&type=script&lang=js"
export * from "./Main.vue?vue&type=script&lang=js"
import style0 from "./Main.vue?vue&type=style&index=0&id=7b85789e&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b85789e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3254644805/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7b85789e')) {
      api.createRecord('7b85789e', component.options)
    } else {
      api.reload('7b85789e', component.options)
    }
    module.hot.accept("./Main.vue?vue&type=template&id=7b85789e&scoped=true", function () {
      api.rerender('7b85789e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Layout/Main.vue"
export default component.exports